import { render, staticRenderFns } from "./micro-page-add.vue?vue&type=template&id=02184d9a&scoped=true&"
import script from "./micro-page-add.vue?vue&type=script&lang=js&"
export * from "./micro-page-add.vue?vue&type=script&lang=js&"
import style0 from "./micro-page-add.vue?vue&type=style&index=0&id=02184d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02184d9a",
  null
  
)

export default component.exports